import { graphql } from "@/lib/gql/__generated__";

export const SEND_SAMPLE_EMAIL_REQUEST_RESERVATION_DECLINED_MUTATION = graphql(`
	mutation TestEmailRequestReservationAtDeclined($input: TestEmailInput!) {
		testEmailRequestReservationAtDeclined(input: $input) {
			userErrors
			status
		}
	}
`);
